.root {
  overflow: hidden;
  position: relative;
  width: 100%;
}

/* --- Vertical (pipeline / leaderboard bars) --- */

.root-direction-vertical {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 40px;
}

.vStripes {
  background: #ffffff;
  height: 25%;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.vLine {
  background: rgba(0, 0, 0, 0.1);
  height: 2px;
  left: 0;
  position: absolute;
  right: 0;
  top: 25%;
}

.vLabel {
  bottom: 10px;
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-weight: 600;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 1;
}

/* --- Horizontal (KPI progress bars) --- */

.root-direction-horizontal {
  border-radius: 6px;
  display: flex;
  height: 28px;
}

.hFill {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 100%;
  justify-content: center;
  min-width: 0;
  padding: 0 8px;
  position: relative;
  transition: width 0.3s ease;
  z-index: 1;
}

.hStripes {
  align-items: center;
  background:
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 6px,
      rgba(255, 255, 255, 0.5) 6px,
      rgba(255, 255, 255, 0.5) 8px
    ),
    rgba(255, 255, 255, 0.35);
  border-left: 2px solid rgba(0, 0, 0, 0.1);
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
  min-width: 0;
  padding: 0 8px;
}

.hFillLabel {
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hStripesLabel {
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
